export const FETCH_COST_TAGS_REQUEST = 'FETCH_COST_TAGS_REQUEST'
export const FETCH_COST_TAGS_SUCCESS = 'FETCH_COST_TAGS_SUCCESS'
export const FETCH_COST_TAGS_FAILED = 'FETCH_COST_TAGS_FAILED'
export const FETCH_COST_TAGS_CATEGORY_REQUEST = 'FETCH_COST_TAGS_CATEGORY_REQUEST'
export const FETCH_COST_TAGS_CATEGORY_SUCCESS = 'FETCH_COST_TAGS_CATEGORY_SUCCESS'
export const FETCH_COST_TAGS_CATEGORY_FAILED = 'FETCH_COST_TAGS_CATEGORY_FAILED'
export const FETCH_COST_TAGS_RESOURCEID_REQUEST = 'FETCH_COST_TAGS_RESOURCEID_REQUEST'
export const FETCH_COST_TAGS_RESOURCEID_SUCCESS = 'FETCH_COST_TAGS_RESOURCEID_SUCCESS'
export const FETCH_COST_TAGS_RESOURCEID_FAILED = 'FETCH_COST_TAGS_RESOURCEID_FAILED'
/** Tags */
export const FETCH_TAGS_ALL_REQUEST = 'FETCH_TAGS_ALL_REQUEST'
export const FETCH_TAGS_ALL_SUCCESS = 'FETCH_TAGS_ALL_SUCCESS'
export const FETCH_TAGS_ALL_FAILED = 'FETCH_TAGS_ALL_FAILED'
